import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";




@Injectable({
    providedIn: 'root'
})
export class GlCodeService extends BaseApiTemplateService<any> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gl-code'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gl-code';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gl-code';
        this.httpClient = http;
    }
    async downloadGlCodeCSV(authorization: string, apiVisa: ApiVisa) {
        const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/import-file-hdr/download-master-data-template';
        const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
        const fileBlob = await this.httpClient
            .get(CSV_URL, { headers, responseType: 'blob' })
            .toPromise();
        return fileBlob;
    }

}

